import Layout from '../components/layout/Layout';
import SectionLabel from '../components/shared/SectionLabel';
import SEO from '../components/shared/SEO';
import '../styles/disclaimerpage.css';

export default function RegulatoryInfoPage() {
  return (
    <Layout>
      <SEO
        title="Regulatory Information - Apex DeFi Labs"
        description="Important regulatory information regarding digital securities investments offered through Apex DeFi Labs and Regiment Securities, LLC."
        url="https://apexdefilabs.com/regulatory-information"
        type="website"
        keywords="Apex DeFi Labs regulatory information, FINRA, SIPC, digital securities, Regulation D"
      />

      <div className="disclaimer-page">
        {/* Hero */}
        <section className="disclaimer-hero">
          <div className="disclaimer-hero-overlay" />
          <div className="disclaimer-shell">
            <div style={{ marginBottom: '1.2rem' }}>
              <SectionLabel>Legal</SectionLabel>
            </div>
            <h1 className="disclaimer-hero-title">
              Regulatory <em>Information</em>
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="disclaimer-content">
          <div className="disclaimer-shell">
            <article className="disclaimer-section">
              <span className="disclaimer-section-number">01</span>
              <h2 className="disclaimer-section-heading">Digital Securities Risk</h2>
              <div className="disclaimer-section-body">
                <p>
                  Investing in digital securities involves significant risk. Digital securities are
                  speculative investments and may not be suitable for all investors. There is no guarantee
                  that investors will receive a return on their investment, and they may lose all or part of
                  their capital. All broker-dealer services, including the sale of securities that may be
                  additionally represented by tokens, are offered and conducted exclusively through Regiment
                  Securities, LLC ("Regiment"), a FINRA-registered broker-dealer and member of SIPC.
                  Regiment does not provide investment advice or recommendations.
                </p>
              </div>
            </article>

            <article className="disclaimer-section">
              <span className="disclaimer-section-number">02</span>
              <h2 className="disclaimer-section-heading">Regulation D Investments</h2>
              <div className="disclaimer-section-body">
                <p>
                  Investments offered under Regulation D are exempt from registration with the SEC and are
                  available only to accredited investors as defined by the Securities Act of 1933. These
                  investments are illiquid and may not be resold except as permitted under applicable
                  securities laws. Prospective investors should carefully consider their financial situation
                  and consult with a financial advisor before investing. Past performance is not indicative
                  of future results, and there is no assurance that any investment strategy will achieve
                  its objectives.
                </p>
              </div>
            </article>
          </div>
        </section>
      </div>
    </Layout>
  );
}
